export function getFor3Layers (obj) {
    const { sport: sportsObjects = {} } = obj;
    const firstSport = sportsObjects[Object.keys(sportsObjects)[0]] || {};
    const { region = {} } = firstSport;
    const firstRegion = region[Object.keys(region)[0]] || {};
    const { competition = {} } = firstRegion;
    const firstCompetition = competition[Object.keys(competition)[0]] || {};
    const { game = {} } = firstCompetition;
    const currentGame = game[Object.keys(game)[0]] || {};
    return currentGame;
}
export function GetArraySportRegion ({ sport: data = {} }) {
    const sportArray = Object.keys(data).filter(item => Object.prototype.hasOwnProperty.call(data, item) && data[item]).map(sportKey => {
        let gameCountForSport = 0;
        const regionArray = Object.keys(data[sportKey].region)
            .filter(item => Object.prototype.hasOwnProperty.call(data[sportKey].region, item))
            .map(regionKey => {
                gameCountForSport += data[sportKey].region[regionKey].game || 0;
                return {
                    id: data[sportKey].region[regionKey].id,
                    name: data[sportKey].region[regionKey].name,
                    order: data[sportKey].region[regionKey].order,
                    alias: data[sportKey].region[regionKey].alias,
                    game: data[sportKey].region[regionKey].game
                };
            });
        return {
            id: data[sportKey].id,
            name: data[sportKey].name,
            order: data[sportKey].order,
            alias: data[sportKey].alias,
            region: regionArray.sort((a, b) => a.order - b.order),
            game: gameCountForSport
        };
    });
    return sportArray.sort((a, b) => a.order - b.order);
}
export function GetArrayVirtualSport ({ sport: data = {} }) {
    const sportAndGameArray = Object.keys(data)
        .filter(item => Object.prototype.hasOwnProperty.call(data, item) && data[item])
        .map(sportKey => {
            const competition = data?.[sportKey]?.competition;
            return competition ? (
                Object.keys(competition)
                    .filter(item => Object.prototype.hasOwnProperty.call(competition, item) && competition[item])
                    .filter(item => Object.keys(competition[item]?.game || {}).length > 0) // filter 
                    .map(competitionKey => {
                        const game = Object.values(competition[competitionKey]?.game || {}).filter(item => item);
                        return {
                            sportId: data[sportKey].id,
                            sportName: data[sportKey].name,
                            sportOrder: data[sportKey].order,
                            sportAlias: data[sportKey].alias,
                            competitionId: competition[competitionKey].id,
                            competitionName: competition[competitionKey].name,
                            videoId: game.find(item => item['video_id'])?.['video_id'] || -1,
                            tvType: game.find(item => item['tv_type'])?.['tv_type'] || -1,
                            game
                        };
                    })
            )?.[0] : data?.[sportKey];
        })
        .filter(item => item);
    return sportAndGameArray.sort((a, b) => a.order - b.order);
}
export function GetArraySport ({ sport: data = {} }) {
    const sportArray = Object.keys(data).filter(item => Object.prototype.hasOwnProperty.call(data, item) && data[item]).map(sportKey => {
        return {
            id: data[sportKey].id,
            name: data[sportKey].name,
            order: data[sportKey].order,
            alias: data[sportKey].alias,
            game: data[sportKey].game,
            type: data[sportKey].type,
            region: data[sportKey].region
        };
    });
    return sportArray.sort((a, b) => a.order - b.order);
}
export function GetArrayRegion ({ region: data = {} }) {
    const regionArray = Object.keys(data).filter(item => Object.prototype.hasOwnProperty.call(data, item) && data[item]).map(regionKey => {
        return {
            id: data[regionKey].id,
            name: data[regionKey].name,
            order: data[regionKey].order,
            alias: data[regionKey].alias,
            game: data[regionKey].game,
            competition: data[regionKey].competition
        };
    });
    return regionArray.sort((a, b) => a.order - b.order);
}
export function GetArrayCompetition ({ competition: data = {} }) {
    const competitionArray = Object.keys(data).filter(item => Object.prototype.hasOwnProperty.call(data, item) && data[item]).map(competitionKey => {
        return {
            id: data[competitionKey].id,
            name: data[competitionKey].name,
            order: data[competitionKey].order,
            game: data[competitionKey].game
        };
    });
    return competitionArray.sort((a, b) => a.order - b.order);
}

export function GetArrayGame (data = {}) {
    const gameArray = Object.keys(data)
        .filter(item => Object.prototype.hasOwnProperty.call(data, item) && data[item])
        .map(gameKey => {
            return {
                id: data[gameKey].id,
                team1_name: data[gameKey].team1_name,
                team2_name: data[gameKey].team2_name,
                start_ts: data[gameKey].start_ts,
                is_live: data[gameKey].is_live,
                is_blocked: data[gameKey].is_blocked,
                markets_count: data[gameKey].markets_count,
                market: data[gameKey].market,
                round: data[gameKey].round,
                video_id: data[gameKey].video_id,
                game_number: data[gameKey].game_number,
                info: data[gameKey].info,
                type: data[gameKey].type,
                order: data[gameKey].order,
            };
        });
    return gameArray.sort((a, b) => a.order - b.order);
}

export function GetArrayMarket (data = {}) {
    const marketArray = Object.keys(data)
        .filter(item => Object.prototype.hasOwnProperty.call(data, item) && data[item])
        .map(marketKey => {
            return {
                id: data[marketKey].id,
                name: data[marketKey].name,
                order: data[marketKey].order,
                event: data[marketKey].event,
                express_id:data[marketKey].express_id
            };
        });
    return marketArray.sort((a, b) => a.order - b.order);
}

export function GetArrayEvent (data = {}) {
    const eventArray = Object.keys(data)
        .filter(item => Object.prototype.hasOwnProperty.call(data, item) && data[item])
        .map(eventKey => {
            return {
                id: data[eventKey].id,
                name: data[eventKey].name,
                type: data[eventKey].type,
                price: data[eventKey].price,
                order: data[eventKey].order,
                base: data[eventKey].base
            };
        });
    return eventArray.sort((a, b) => a.order - b.order);
}

export function GetArrayForAllLayers(data = {}, stopOn) {
    const result = GetArraySport(data).reduce((acc, sport) => {
        if (!sport.region || stopOn === 'sport')
            return acc.push(sport);

        GetArrayRegion(sport).map(region => {
            if (!region.competition || stopOn === 'region')
                return acc.push({ ...region, sport });

            GetArrayCompetition(region).map(competition => {
                if (!competition.game || stopOn === 'competition')
                    return acc.push({ ...competition, sport, region });

                GetArrayGame(competition.game).map(game => {
                    if (!game.market || stopOn === 'game')
                        return acc.push({ ...game, sport, region, competition });

                    GetArrayMarket(game.market).map(market => {
                        if (!market.event || stopOn === 'market')
                            return acc.push({ ...market, sport, region, competition, game });

                        GetArrayEvent(market.event).map(event => {
                            acc.push({ ...event, sport, region, competition, game, market });
                        });
                    })
                })
            });
        })
        
        return acc;
    }, []);

    return result.sort((a, b) => a.order - b.order);
};